<template>
  <div>
    <div class="lx_wrap">
      <div class="lx_content">
        <img src="../../../assets/images/public/i3.png" class="lx_logo" />
        <div class="lx_mid">
          <div class="lx_adr">
            <h3>{{ footer.title1 }}</h3>
            <div>{{ footer.title2 }}</div>
          </div>
          <div class="lx_us">
            <h3>{{ footer.callMe.title }}</h3>
            <span v-for="(item, i) in footer.callMe.list" :key="i">{{
              item
            }}</span>
            <ul style="display: flex;">
              <li
                v-for="(item, index) in footer.qrcodeList"
                :key="index"
                @mouseenter="enter(index)"
                @mouseleave="leave(index)"
                style="position: relative;"
                
              >
              <img class="lx_wx" :src="item.icon" v-if="!item.seen" style="border-radius: 50%;"/>
              <img class="lx_wx" :src="item.selectIcon" v-if="item.seen" alt="" />
              <div v-if="item.seen" class="lx_dialog1">
                  <img :src="item.qrIcon" class="maImg" />
                  <div>{{ item.name }}</div>
                </div>
            </li>
              <!-- <img class="lx_wx" src="../../../assets/images/public/i4.png" />
              <img class="lx_wx" src="../../../assets/images/public/i5.png" /> -->
            </ul>
          </div>
        </div>
        <div class="lx_right">
          <div v-if="footer.phoneTxt">
            <h3>{{ footer.phoneTxt }}</h3>
            <h2>+86-189-6183-2100</h2>
          </div>
          <div class="community_accout">
            <h3>{{ footer.attentionOurTxt }}</h3>
            <div class="lx_sml">
              <div
                v-for="(item, index) in footer.imgList"
                :key="index"
                @mouseenter="onMouseOver(index)"
                @mouseleave="onMouseOut(index)"
              >
                <div v-if="item.isShow" class="lx_dialog">
                  <img :src="item.qrIcon" class="maImg" />
                  <div>{{ item.name }}</div>
                </div>
                <img class="smlIcon" :src="item.icon" v-if="!item.isShow" />
              <img class="smlIcon" :src="item.selectIcon" v-if="item.isShow" alt="" />
              </div>
            </div>
          </div>
          <div class="lx_right__bottom">
            <div class="message-detail__link" @click="goMessageDetails">
              <span>{{ contactUs.messageDetailsTxt }}</span>
              <i class="el-icon-s-promotion"></i>
            </div>
          </div>
        </div>
      </div>
      <div class="lx_bot">
        <div class="lx_box">
          <div>{{ footer.copyrightTxt }}</div>
          <div>Copyright 2009-2015 @ KELK,ALL right reserved</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      imgList: [
        {
          icon: require("../../../assets/images/public/i10.png"),
          selectIcon: require("../../../assets/images/public/i11.png"),
          name: "公众号",
          isShow: false
        },
        {
          icon: require("../../../assets/images/public/i9.png"),
          selectIcon: require("../../../assets/images/public/i11.png"),
          name: "视频号",
          isShow: false
        },
        {
          icon: require("../../../assets/images/public/i8.png"),
          selectIcon: require("../../../assets/images/public/i11.png"),
          name: "小程序",
          isShow: false
        }
      ]
    };
  },

  computed: {
    ...mapGetters(["currentLang"]),
    footer() {
      return this.currentLang.config.footer;
    },
    contactUs() {
      return this.currentLang.config.contactUs;
    }
  },

  methods: {
    onMouseOver(index) {
      this.footer.imgList[index].isShow = true;
    },
    onMouseOut(index) {
      this.footer.imgList[index].isShow = false;
    },
    enter(index) {
      this.footer.qrcodeList[index].seen = true;
    },
    leave(index) {
      this.footer.qrcodeList[index].seen = false;
      // this.current = null;
    },

    goMessageDetails() {
      this.$router.push('/message-record')
    }
  }
};
</script>

<style lang="scss" scoped>
.lx_wrap {
  width: 100%;
  height: auto;
  padding-top: 50px;
  background: #464646 url("../../../assets/images/public/bg6.png") no-repeat center;
  background-size: 70% 80%;

  .lx_content {
    max-width: 1200px;
    margin: auto;
    display: flex;

    .lx_logo {
      width: 120px;
      height: 120px;
      margin-right: 20px;
    }
  }

  .lx_mid {
    color: white;

    .lx_adr {
      margin-bottom: 50px;

      h3 {
        margin-bottom: 10px;
      }
    }

    .lx_us span {
      display: inherit;
      margin-top: 10px;
    }

    .lx_wx {
      width: 40px;
      height: 40px;
      margin-top: 20px;
      margin-right: 10px;
    }

    .lx_wx:hover {
      cursor: pointer;
    }
    .lx_dialog1 {
      width: 80px;
      height: auto;
      color: black;
      padding: 5px;
      text-align: center;
      background: white;
      font-size: 12px;
      border-radius: 5px;
      position: absolute;
      bottom: 56px;
      left: -21px;
      .maImg {
        width: 100%;
        height: auto;
      }
    }

    .lx_sml {
      display: flex;
      
      .smlIcon {
        width: 30px;
        height: 30px;
        margin-top: 15px;
        margin-right: 10px;
      }
    }
  }

  .lx_right {
    margin-left: 200px;
    width: 360px;
    position: relative;
    h2 {
      color: #ea3139;
      margin-top: 10px;
    }

    h3 {
      color: white;
    }

    .community_accout {
      margin-top: 38px;
    }

    .lx_dialog {
      width: 80px;
      height: auto;
      color: black;
      padding: 5px;
      text-align: center;
      background: white;
      font-size: 12px;
      border-radius: 5px;
      position: absolute;
      bottom: 160px;
      left: 10px;
      .maImg {
        width: 100%;
        height: auto;
      }
    }

    .lx_sml {
      display: flex;
      cursor: pointer;
      .smlIcon {
        width: 40px;
        height: 40px;
        margin-top: 15px;
        margin-right: 10px;
      }
    }

    .lx_right__bottom {
      margin-top: 75px;
      color: #fff;
      font-size: 17px;

      .message-detail__link {
        display: inline-block;
        transition: all 0.05s!important;
        text-decoration: underline;
        cursor: pointer;
      }

      .message-detail__link:hover {
        color: var(--main-color);
      }
    }
  }

  .lx_bot {
    width: 100%;
    height: 40px;
    line-height: 40px;
    color: gray;
    font-size: 12px;
    margin-top: 30px;
    background-color: #343434;

    .lx_box {
      width: 1000px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/footer/modules/footer_cn.vue